export const headerColumns = [
  { label: 'Customer', flex: 1.75 },
  { label: 'Order', flex: 1 },
  { label: 'Sale Type', flex: 1 },
  { label: 'Cart', flex: 1 },
  { label: 'Time In', flex: 1.5, noBorder: true },
];
